import type { IntrinsicSystemProps, MotionPropsFor } from '@hover/blueprint';
import { calc, forwardRef, motion } from '@hover/blueprint';
import React from 'react';

import { $imageBorderRadius, imagePadding } from './constants';

export interface HistoryImageProps
  extends MotionPropsFor<IntrinsicSystemProps<'img'>> {}

const HistoryImage = forwardRef<HistoryImageProps, 'img'>((props, ref) => (
  <motion.img
    borderColor="transparent"
    borderLeftWidth={imagePadding}
    borderRadius={calc.add($imageBorderRadius, imagePadding)}
    borderStyle="solid"
    borderWidth={imagePadding}
    boxSizing="border-box"
    height="auto"
    layout
    margin="0 !important"
    maxHeight="100%"
    maxWidth="100%"
    width="auto"
    {...props}
    ref={ref}
  />
));

export { HistoryImage };
